import { all, call, fork, put, takeEvery } from "redux-saga/effects";

// Calender Redux States
import {
    GET_ATTACHMENT,
    GET_CITY,
    GET_COUNTRY,
    GET_GENERAL,
    SEARCH_GENERAL,
    GET_PROFILE_ATTACHMENT,
    GET_REGION,
    GET_STATE,
    GET_THUMBNAIL_ATTACHMENT,
    SEND_EMAIL,
    SET_CURRENT_USER,
    GET_ADVERT_INTEREST_RATE,
    ACCEPT_INVITATION
} from "./actionTypes.js";

import {
    getAttachmentFail,
    getAttachmentSuccess,
    getCityFail,
    getCitySuccess,
    getCountryFail,
    getCountrySuccess,
    searchGeneralFail,
    searchGeneralSuccess,
    getProfileAttachmentFail,
    getProfileAttachmentSuccess,
    getRegionFail,
    getRegionSuccess,
    getStateFail,
    getStateSuccess,
    getThumbnailAttachmentFail,
    getThumbnailAttachmentSuccess,
    sendEmailFail,
    sendEmailSuccess,
    setCurrentUser,
    getAdvertInterestRateSuccess,
    getAdvertInterestRateFail,
    acceptInvitationSuccess,
    acceptInvitationFail,
    getGeneralSuccess,
    getGeneralFail
} from "./action.js";

import {
    attachmentApi,
    cityListingApi,
    countryListingApi,
    generalApi,
    regionByPostcodeListingApi,
    sendEmailApi,
    stateListingApi,
    advertInterestRateApi,
    acceptInvitationApi
} from "./generalApi.js";

function* fetchGeneral({payload}) {
    try {
        const response = yield call(generalApi, payload)
        yield put(getGeneralSuccess(response))
    } catch (error) {
        yield put(getGeneralFail(error))
    }
}

function* searchGeneral({payload}) {
    try {
        const response = yield call(generalApi, payload)
        yield put(searchGeneralSuccess(response))
    } catch (error) {
        yield put(searchGeneralFail(error))
    }
}

function* fetchCountry() {
    try {
        const response = yield call(countryListingApi)
        yield put(getCountrySuccess(response))
    } catch (error) {
        yield put(getCountryFail(error))
    }
}

function* fetchState({ payload }) {
    try {
        const response = yield call(stateListingApi, payload)
        yield put(getStateSuccess(response))
    } catch (error) {
        yield put(getStateFail(error))
    }
}

function* fetchCity({ payload }) {
    try {
        const response = yield call(cityListingApi, payload)
        yield put(getCitySuccess(response))
    } catch (error) {
        yield put(getCityFail(error))
    }
}

function* fetchRegion({ payload }) {
    try {
        const response = yield call(regionByPostcodeListingApi, payload)
        yield put(getRegionSuccess(response))
    } catch (error) {
        yield put(getRegionFail(error))
    }
}

function* fetchAttachment({ payload }) {
    try {
        const response = yield call(attachmentApi, payload)
        yield put(getAttachmentSuccess(response))
    } catch (error) {
        yield put(getAttachmentFail(error))
    }
}

function* fetchProfileAttachment({ payload }) {
    try {
        const response = yield call(attachmentApi, payload)
        yield put(getProfileAttachmentSuccess(response))
    } catch (error) {
        yield put(getProfileAttachmentFail(error))
    }
}

function* fetchThumbnailAttachment({ payload }) {
    try {
        const response = yield call(attachmentApi, payload)
        yield put(getThumbnailAttachmentSuccess(response))
    } catch (error) {
        yield put(getThumbnailAttachmentFail(error))
    }
}

function* fetchSendEmail({ payload }) {
    try {
        const response = yield call(sendEmailApi, payload)
        yield put(sendEmailSuccess(response))
    } catch (error) {
        yield put(sendEmailFail(error))
    }
}

function* setUser({ payload }) {
    try {
        yield call(setCurrentUser, payload);
    } catch (error) { }
}

function* fetchAdvertInterestRate({ payload }) {
    try {
        const response = yield call(advertInterestRateApi, payload);
        yield put(getAdvertInterestRateSuccess(response));
    } catch (error) {
        yield put(getAdvertInterestRateFail(error));
    }
}

function* fetchAcceptInvitation({ payload }) {
    try {
        const response = yield call(acceptInvitationApi, payload);
        yield put(acceptInvitationSuccess(response));
    } catch (error) {
        yield put(acceptInvitationFail(error));
    }
}


export function* watchCurrentUser() {
    yield takeEvery(SET_CURRENT_USER, setUser);
}

function* GeneralSaga() {
    yield all([
        fork(watchCurrentUser),
    ])
    yield takeEvery(GET_GENERAL, fetchGeneral)
    yield takeEvery(SEARCH_GENERAL, searchGeneral)
    yield takeEvery(GET_COUNTRY, fetchCountry)
    yield takeEvery(GET_STATE, fetchState)
    yield takeEvery(GET_CITY, fetchCity)
    yield takeEvery(GET_REGION, fetchRegion)
    yield takeEvery(GET_ATTACHMENT, fetchAttachment)
    yield takeEvery(GET_PROFILE_ATTACHMENT, fetchProfileAttachment)
    yield takeEvery(GET_THUMBNAIL_ATTACHMENT, fetchThumbnailAttachment)
    yield takeEvery(SEND_EMAIL, fetchSendEmail)
    yield takeEvery(GET_ADVERT_INTEREST_RATE, fetchAdvertInterestRate);
    yield takeEvery(ACCEPT_INVITATION, fetchAcceptInvitation);
}

export default GeneralSaga
